import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomRequisitionPrecedent } from '@models/requisitions';
import { SnackbarService } from '@services/ui/snackbar.service';
import {
	BaseCustomRequisitionModal,
	INewCustomRequisitionModalData,
} from '../base-custom-requisition-modal';
import { createId } from '@core/util/file';
import { BusinessRequisitionsDispatch } from '@state/business/requisition/business_requisitions.dispatch';
import { TestHooks } from './new-custom-requisition-modal.hooks';

@Component({
	selector: 'app-new-custom-requisition-modal',
	templateUrl: './new-custom-requisition-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class NewCustomRequisitionModalComponent extends BaseCustomRequisitionModal {
	testHooks = TestHooks;
	successMessage = 'Custom Requisition Created Successfully';
	errorMessage = 'Error creating custom requisition';
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: INewCustomRequisitionModalData,
		protected dialogRef: MatDialogRef<
			NewCustomRequisitionModalComponent,
			string
		>,
		protected businessRequisitionDispatch: BusinessRequisitionsDispatch,
		protected snackbarService: SnackbarService,
	) {
		super(data, dialogRef, businessRequisitionDispatch, snackbarService);
	}

	onSubmitAction(requisition: CustomRequisitionPrecedent) {
		const updatedRequisition = { ...requisition, id: createId() };
		this.businessRequisitionDispatch.Create(updatedRequisition);
		return updatedRequisition;
	}
}
